import {
  Cliente,
  Delegacion,
  ICliente,
  IDelegacion,
  IParametro,
  IPuntoServicio,
  IUsuarioxVideo,
  IVideo,
  PuntoServicio,
  Parametro,
} from "@/entities";

export class Video implements IVideo {
  id: number;
  cedulasCiudadania: string;
  ciudad: string;
  cliente: ICliente;
  fecha: string;
  fechaNovedad: string;
  fechaSubida: string;
  nombreRevisores: string;
  nombreVideo?: string;
  observaciones: string;
  puntoServicio: IPuntoServicio;
  delegacion: IDelegacion;
  sucursal: string;
  urlVideo: string;
  listUsuarios?: IUsuarioxVideo[];
  estado: IParametro;
  tipoNovedad?: IParametro;
  importe?: number | null;

  constructor() {
    this.id = 0;
    this.cedulasCiudadania = "";
    this.ciudad = "";
    this.cliente = new Cliente();
    this.fecha = "";
    this.fechaNovedad = "";
    this.fechaSubida = "";
    this.nombreRevisores = "";
    this.observaciones = "";
    this.puntoServicio = new PuntoServicio();
    this.delegacion = new Delegacion();
    this.sucursal = "";
    this.nombreVideo = "";
    this.urlVideo = "";
    this.estado = new Parametro();
  }
}
